import React from 'react';
import { Box, Image } from '@chakra-ui/react';

/**
 * Brand logos from mobile assets.
 * - `mark` = icon only (sidebar collapsed / favicon-size)
 * - `full` = icon + UTKARSH wordmark + tagline
 */
export function BrandLogo({
  variant = 'full',
  h = variant === 'full' ? '40px' : '36px',
  maxW,
  ...props
}) {
  const src =
    variant === 'mark'
      ? '/brand/app_icon.png'
      : '/brand/app_logo_full.png';
  const alt = variant === 'mark' ? 'Utkarsh' : 'Utkarsh — A Buyer Seller Portal';

  return (
    <Box lineHeight={0} {...props}>
      <Image
        src={src}
        alt={alt}
        h={h}
        maxW={maxW}
        w="auto"
        objectFit="contain"
        display="block"
      />
    </Box>
  );
}
